import { ContentModuleType, Space } from '@tribeplatform/gql-client/types'

import { EventComposer } from './EventComposer.js'

interface Props {
  contentModuleType: ContentModuleType
  eventPath?: string
  selectedSpace?: Space
  onCancel: () => void
}

export const ContentModuleComposer = ({
  eventPath,
  selectedSpace,
  onCancel,
  contentModuleType,
}: Props) => {
  /**
   * The check for content module type is for new event form which includes content_type=event
   * and the eventPath is for edit event form.
   */
  if (contentModuleType === ContentModuleType.event || !!eventPath) {
    return (
      <EventComposer
        eventPath={eventPath}
        selectedSpace={selectedSpace}
        onCancel={onCancel}
      />
    )
  }

  return null
}
